import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Button, Space, Typography } from 'antd';
import SignatureCanvas from 'react-signature-canvas';

const { Text } = Typography;

export interface PortalSignaturePadHandle {
  isEmpty: () => boolean;
  toDataURL: () => string;
  clear: () => void;
}

export interface PortalSignaturePadProps {
  onCapture: (dataUrl: string) => void;
}

const PortalSignaturePad = forwardRef<PortalSignaturePadHandle, PortalSignaturePadProps>(({ onCapture }, ref) => {
  const sigRef = useRef<SignatureCanvas | null>(null);

  useImperativeHandle(ref, () => ({
    isEmpty: () => !sigRef.current || sigRef.current.isEmpty(),
    toDataURL: () => sigRef.current?.toDataURL('image/png') ?? '',
    clear: () => sigRef.current?.clear(),
  }));

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Text>Sign here:</Text>
      <div style={{ border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}>
        <SignatureCanvas
          ref={(r) => { sigRef.current = r; }}
          canvasProps={{
            style: { display: 'block', width: '100%', height: 200, touchAction: 'none' },
          }}
          onEnd={() => {
            const url = sigRef.current?.toDataURL('image/png');
            if (url) onCapture(url);
          }}
        />
      </div>
      <Button onClick={() => sigRef.current?.clear()} type="link">Clear</Button>
    </Space>
  );
});

PortalSignaturePad.displayName = 'PortalSignaturePad';
export default PortalSignaturePad;
